webpackJsonp([124],{

/***/ 1017:
/***/ (function(module, exports) {

module.exports = {"name":"ant-design-vue","version":"1.7.8","title":"Ant Design Vue","description":"An enterprise-class UI design language and Vue-based implementation","keywords":["ant","design","antd","vue","vueComponent","component","components","ui","framework","frontend"],"main":"lib/index.js","module":"es/index.js","typings":"types/index.d.ts","files":["dist","lib","es","types","scripts"],"scripts":{"dev":"webpack-dev-server","start":"cross-env NODE_ENV=development webpack-dev-server --config webpack.config.js","test":"cross-env NODE_ENV=test jest --config .jest.js","compile":"node antd-tools/cli/run.js compile","pub":"node antd-tools/cli/run.js pub","pub-with-ci":"node antd-tools/cli/run.js pub-with-ci","prepublish":"node antd-tools/cli/run.js guard","pre-publish":"node ./scripts/prepub","prettier":"prettier -c --write '**/*'","pretty-quick":"pretty-quick","dist":"node antd-tools/cli/run.js dist","lint":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./components","lint:site":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./antdv-demo","lint:docs":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue,.md ./antdv-demo/docs/**/demo/**","lint:style":"stylelint \"{site,components}/**/*.less\" --syntax less","codecov":"codecov","postinstall":"node scripts/postinstall || echo \"ignore\""},"repository":{"type":"git","url":"git+https://github.com/vueComponent/ant-design-vue.git"},"license":"MIT","bugs":{"url":"https://github.com/vueComponent/ant-design-vue/issues"},"homepage":"https://www.antdv.com/","peerDependencies":{"vue":"^2.6.0","vue-template-compiler":"^2.6.0"},"devDependencies":{"@commitlint/cli":"^8.0.0","@commitlint/config-conventional":"^8.0.0","@octokit/rest":"^16.0.0","@vue/cli-plugin-eslint":"^4.0.0","@vue/server-test-utils":"1.0.0-beta.16","@vue/test-utils":"1.0.0-beta.16","acorn":"^7.0.0","autoprefixer":"^9.6.0","axios":"^0.19.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-eslint":"^10.0.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-jest":"^23.6.0","babel-loader":"^7.1.2","babel-plugin-import":"^1.1.1","babel-plugin-inline-import-data-uri":"^1.0.1","babel-plugin-istanbul":"^6.0.0","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-decorators":"^6.24.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-es3-member-expression-literals":"^6.22.0","babel-plugin-transform-es3-property-literals":"^6.22.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"~6.23.0","babel-plugin-transform-vue-jsx":"^3.7.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","case-sensitive-paths-webpack-plugin":"^2.1.2","chalk":"^3.0.0","cheerio":"^1.0.0-rc.2","codecov":"^3.0.0","colorful":"^2.1.0","commander":"^4.0.0","compare-versions":"^3.3.0","cross-env":"^7.0.0","css-loader":"^3.0.0","deep-assign":"^2.0.0","enquire-js":"^0.2.1","eslint":"^6.8.0","eslint-config-prettier":"^6.10.1","eslint-plugin-html":"^6.0.0","eslint-plugin-markdown":"^2.0.0-alpha.0","eslint-plugin-vue":"^6.2.2","fetch-jsonp":"^1.1.3","fs-extra":"^8.0.0","glob":"^7.1.2","gulp":"^4.0.1","gulp-babel":"^7.0.0","gulp-strip-code":"^0.1.4","html-webpack-plugin":"^3.2.0","husky":"^4.0.0","istanbul-instrumenter-loader":"^3.0.0","jest":"^24.0.0","jest-serializer-vue":"^2.0.0","jest-transform-stub":"^2.0.0","js-base64":"^3.0.0","json-templater":"^1.2.0","jsonp":"^0.2.1","less":"^3.9.0","less-loader":"^6.0.0","less-plugin-npm-import":"^2.1.0","lint-staged":"^10.0.0","marked":"0.3.18","merge2":"^1.2.1","mini-css-extract-plugin":"^0.10.0","minimist":"^1.2.0","mkdirp":"^0.5.1","mockdate":"^2.0.2","nprogress":"^0.2.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss":"^7.0.6","postcss-loader":"^3.0.0","prettier":"^1.18.2","pretty-quick":"^2.0.0","querystring":"^0.2.0","raw-loader":"^4.0.0","reqwest":"^2.0.5","rimraf":"^3.0.0","rucksack-css":"^1.0.2","selenium-server":"^3.0.1","semver":"^7.0.0","style-loader":"^1.0.0","stylelint":"^13.0.0","stylelint-config-prettier":"^8.0.0","stylelint-config-standard":"^19.0.0","terser-webpack-plugin":"^3.0.3","through2":"^3.0.0","url-loader":"^3.0.0","vue":"^2.6.11","vue-antd-md-loader":"^1.1.0","vue-clipboard2":"0.3.1","vue-draggable-resizable":"^2.1.0","vue-eslint-parser":"^7.0.0","vue-i18n":"^8.3.2","vue-infinite-scroll":"^2.0.2","vue-jest":"^2.5.0","vue-loader":"^15.6.2","vue-router":"^3.0.1","vue-server-renderer":"^2.6.11","vue-template-compiler":"^2.6.11","vue-virtual-scroller":"^1.0.0","vuex":"^3.1.0","webpack":"^4.28.4","webpack-cli":"^3.2.1","webpack-dev-server":"^3.1.14","webpack-merge":"^4.1.1","webpackbar":"^4.0.0","xhr-mock":"^2.5.1"},"dependencies":{"@ant-design/icons":"^2.1.1","@ant-design/icons-vue":"^2.0.0","@simonwep/pickr":"~1.7.0","add-dom-event-listener":"^1.0.2","array-tree-filter":"^2.1.0","async-validator":"^3.0.3","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-runtime":"6.x","classnames":"^2.2.5","component-classes":"^1.2.6","dom-align":"^1.10.4","dom-closest":"^0.2.0","dom-scroll-into-view":"^2.0.0","enquire.js":"^2.1.6","intersperse":"^1.0.0","is-mobile":"^2.2.1","is-negative-zero":"^2.0.0","ismobilejs":"^1.0.0","json2mq":"^0.2.0","lodash":"^4.17.5","moment":"^2.21.0","mutationobserver-shim":"^0.3.2","node-emoji":"^1.10.0","omit.js":"^1.0.0","raf":"^3.4.0","resize-observer-polyfill":"^1.5.1","shallow-equal":"^1.0.0","shallowequal":"^1.0.2","vue-ref":"^2.0.0","warning":"^4.0.0"},"sideEffects":["site/*","components/style.js","components/**/style/*","*.vue","*.md","dist/*","es/**/style/*","lib/**/style/*","*.less"]}

/***/ }),

/***/ 1037:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_mask__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_env__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_service__ = __webpack_require__(201);









var numeral = __webpack_require__(533);
var moment = __webpack_require__(3);
var ThaiBaht = __webpack_require__(1041);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_v_mask__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      header: {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.token
        }
      },
      title_web: __WEBPACK_IMPORTED_MODULE_7__config_env__["a" /* default */].titleWeb,
      description_web: __WEBPACK_IMPORTED_MODULE_7__config_env__["a" /* default */].descriptionWeb
    };
  },

  methods: {
    checkOAuth: function checkOAuth() {
      var token = sessionStorage.token;
      if (token) {
        this.checkToken(token);
      } else if (localStorage.refresh_token) {
        this.OAuthToken();
      } else {
        localStorage.clear();
        sessionStorage.clear();
        this.$store.state.user = undefined;
        if (this.$route.path !== '/login') {
          this.$router.push('/login');
        }
      }
    },
    checkToken: function checkToken(token) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var jwt, TimoOutLogin;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                jwt = Object(__WEBPACK_IMPORTED_MODULE_5_jwt_decode__["a" /* default */])(token);

                if (!(jwt !== null)) {
                  _context.next = 13;
                  break;
                }

                TimoOutLogin = _this.daysDiff(_this.dateFormatFullTime(new Date()), jwt.expire);

                if (!(parseInt(TimoOutLogin) <= 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.OAuthToken();

              case 7:
                _context.next = 11;
                break;

              case 9:
                _context.next = 11;
                return _this.checkPermission(jwt.role_id);

              case 11:
                _context.next = 14;
                break;

              case 13:
                _this.OAuthToken();

              case 14:
                _context.next = 28;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);

                // The access token may be missing, malformed, or left over from an
                // older session. Recover with the refresh token instead of leaving
                // the application stuck after jwt_decode throws "Invalid token".
                sessionStorage.removeItem('token');

                if (!localStorage.refresh_token) {
                  _context.next = 24;
                  break;
                }

                _context.next = 22;
                return _this.OAuthToken();

              case 22:
                _context.next = 28;
                break;

              case 24:
                localStorage.clear();
                sessionStorage.clear();
                _this.$store.state.user = undefined;
                if (_this.$route.path !== '/login') {
                  _this.$router.push('/login');
                }

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 16]]);
      }))();
    },
    OAuthToken: function OAuthToken() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var obj;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.$route.path !== 'login' && _this2.$route.path !== '/404')) {
                  _context2.next = 4;
                  break;
                }

                obj = {
                  refresh_token: localStorage.refresh_token
                };
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__models_service__["a" /* default */].OAuth(_this2.$store.state.URLHost, obj, function (result) {
                  if (result.response === true) {
                    sessionStorage.token = result.data.access_token;
                    _this2.header = {
                      headers: {
                        Authorization: 'Bearer ' + sessionStorage.token
                      }
                    };
                    setTimeout(function () {
                      _this2.checkToken(sessionStorage.token);
                    }, 500);
                  } else {
                    $('.preloader').fadeOut();
                    __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                      title: result.message,
                      text: 'You have logged in more than the specified time',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#F43131',
                      confirmButtonText: 'Logout',
                      cancelButtonText: 'Again',
                      reverseButtons: true,
                      customClass: 'Custom_Cancel'
                    }).then(function (result) {
                      if (result.isConfirmed) {
                        _this2.logOut();
                        return false;
                      } else {
                        _this2.OAuthToken();
                        return false;
                      }
                    });
                  }
                }, function (error) {
                  $('.preloader').fadeOut();
                  if (error.message === 'Network Error') {
                    _this2.alert_msg('error', 'Check', 'Unable to login because ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error.message));
                    localStorage.clear();
                    sessionStorage.clear();
                    _this2.$store.state.user = undefined;
                    _this2.$router.push('/login');
                    // eslint-disable-next-line no-undef
                    $('.preloader').fadeOut();
                  } else {
                    __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                      title: error.message,
                      text: 'There is a problem with your key, would you like to log out ?',
                      icon: 'error',
                      showCancelButton: true,
                      confirmButtonColor: '#F43131',
                      confirmButtonText: 'Logout',
                      cancelButtonText: 'Again',
                      reverseButtons: true,
                      customClass: 'Custom_Cancel'
                    }).then(function (result) {
                      if (result.isConfirmed) {
                        _this2.logOut();
                      } else {
                        _this2.OAuthToken();
                      }
                    });
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    alert_msg: function alert_msg(type, title) {
      var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      switch (type) {
        // eslint-disable-next-line no-undef
        case 'success':
          toastr.success(text, title, { progressBar: true, closeButton: true });
          break;
        // eslint-disable-next-line no-undef
        case 'info':
          toastr.info(text, title, { progressBar: true, closeButton: true });
          break;
        // eslint-disable-next-line no-undef
        case 'warning':
          toastr.warning(text, title, { progressBar: true, closeButton: true });
          break;
        // eslint-disable-next-line no-undef
        case 'error':
          toastr.error(text, title, { progressBar: true, closeButton: true });
          break;
      }
    },
    reload: function reload() {
      this.$store.state.isLoading = true;
      location.reload();
    },
    ModalBoots: function ModalBoots(Id) {
      // eslint-disable-next-line no-undef
      return new bootstrap.Modal(document.getElementById(Id), {
        backdrop: 'static', // 👈 คลิกข้างนอกไม่ปิด
        keyboard: false // 👈 กด ESC ไม่ปิด
      });
    },
    daysDiff: function daysDiff(d1, d2) {
      var startDate = moment(d1).format('x');
      // Do your operations
      var endDate = moment(d2).format('x');
      var seconds = (endDate - startDate) / 60000;
      return Math.floor(seconds);
    },
    getLastDate: function getLastDate(Data) {
      var res = Data.split('-');
      var month = res[1]; // January
      var year = res[0];
      var d = new Date(year, month, 0);
      return moment(d).format('DD');
    },
    dateYearThai: function dateYearThai(date) {
      return parseInt(moment(date).format('YYYY')) + 543;
    },
    dateMonth: function dateMonth(date) {
      return moment(date).format('YYYY-MM');
    },
    dateFormatAndTime: function dateFormatAndTime(date) {
      moment.locale();
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    dateFormatAndFulltime: function dateFormatAndFulltime(date) {
      moment.locale();
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    dateFormatFullTime: function dateFormatFullTime(date) {
      moment.locale();
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    dateConvertYMD: function dateConvertYMD(date) {
      var res = date.split('/');
      return res[2] + '-' + res[1] + '-' + res[0];
    },
    dateFormatDMY: function dateFormatDMY(date) {
      moment.locale();
      return moment(date).format('DD/MM/YYYY');
    },
    dateFormatYYYYMMDD: function dateFormatYYYYMMDD(date) {
      moment.locale();
      return moment(date).format('YYYYMMDD');
    },
    dateFormatDMY2: function dateFormatDMY2(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    dateFormatYMD: function dateFormatYMD(date) {
      moment.locale();
      return moment(date).format('YYYY-MM-DD');
    },
    dateFormatDDMMYYYY: function dateFormatDDMMYYYY(date) {
      moment.locale();
      return moment(date).format('DD-MM-YYYY');
    },
    dateFormatMY: function dateFormatMY(date) {
      moment.locale();
      return moment(date).format('MM/YYYY');
    },
    dateFormatMil: function dateFormatMil(date) {
      moment.locale();
      return moment(date).format();
    },
    dateFormatTime: function dateFormatTime(date) {
      moment.locale();
      return moment(date).format('HH:mm');
    },
    monthFormat: function monthFormat(str) {
      switch (str) {
        case '01':
          return 'ม.ค';
        case '02':
          return 'ก.พ';
        case '03':
          return 'มี.ค';
        case '04':
          return 'เม.ย';
        case '05':
          return 'พ.ค';
        case '06':
          return 'มิ.ย';
        case '07':
          return 'ก.ค';
        case '08':
          return 'ส.ค';
        case '09':
          return 'ก.ย';
        case '10':
          return 'ต.ค';
        case '11':
          return 'พ.ย';
        default:
          return 'ธ.ค';
      }
    },
    monthYearFormat: function monthYearFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0];
        case '02':
          return 'กุมภาพันธ์ ' + date[0];
        case '03':
          return 'มีนาคม ' + date[0];
        case '04':
          return 'เมษายน ' + date[0];
        case '05':
          return 'พฤษภาคม ' + date[0];
        case '06':
          return 'มิถุนายน ' + date[0];
        case '07':
          return 'กรกฎาคม ' + date[0];
        case '08':
          return 'สิงหาคม ' + date[0];
        case '09':
          return 'กันยายน ' + date[0];
        case '10':
          return 'ตุลาคม ' + date[0];
        case '11':
          return 'พฤศจิกายน ' + date[0];
        default:
          return 'ธันวาคม ' + date[0];
      }
    },
    dateThaiFormat: function dateThaiFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return date[2] + ' มกราคม ' + (date[0] + 543);
        case '02':
          return date[2] + ' กุมภาพันธ์ ' + (date[0] + 543);
        case '03':
          return date[2] + ' มีนาคม ' + (date[0] + 543);
        case '04':
          return date[2] + ' เมษายน ' + (date[0] + 543);
        case '05':
          return date[2] + ' พฤษภาคม ' + (date[0] + 543);
        case '06':
          return date[2] + ' มิถุนายน ' + (date[0] + 543);
        case '07':
          return date[2] + ' กรกฎาคม ' + (date[0] + 543);
        case '08':
          return date[2] + ' สิงหาคม ' + (date[0] + 543);
        case '09':
          return date[2] + ' กันยายน ' + (date[0] + 543);
        case '10':
          return date[2] + ' ตุลาคม ' + (date[0] + 543);
        case '11':
          return date[2] + ' พฤศจิกายน ' + (date[0] + 543);
        default:
          return date[2] + ' ธันวาคม ' + (date[0] + 543);
      }
    },
    numberFormatDecimal: function numberFormatDecimal(str) {
      return numeral(str).format('0,0.00');
    },
    numberFormat: function numberFormat(str) {
      return numeral(str).format('0,0');
    },
    numberFormat4: function numberFormat4(str) {
      return numeral(str).format('0000');
    },
    moneyText: function moneyText(str) {
      return ThaiBaht(str);
    },
    convert_vs: function convert_vs(val) {
      var data = [];
      var len = 3;
      if (val.length > 3) {
        len = val.length;
      }
      var vallen = val.length;
      for (var i = 0; i < len; i++) {
        var v = val.split('');
        if (len - i === vallen) {
          var ss = len - i;
          if (ss === vallen) {
            if (val.length === 1) {
              data.push(val);
            } else if (len > val.length) {
              data.push(v[i - 1]);
            } else {
              data.push(v[i]);
            }
          } else {
            data.push(v[i - 1]);
          }
          vallen--;
        } else {
          data.push('0');
        }
      }
      var versions = '';
      for (var l = 0; l < data.length; l++) {
        versions += data[l];
        if (l < data.length - 1) {
          versions += '.';
        }
      }
      return versions;
    },
    DataURIToBlob: function DataURIToBlob(dataURI) {
      var binary = atob(dataURI.split(',')[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
    },
    playSound: function playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    toDo: function toDo() {
      this.alert_msg('warning', 'To Do', 'Develop is process');
    },
    getProfile: function getProfile() {
      var _this3 = this;

      $('.preloader').fadeOut();
      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_8__models_service__["a" /* default */].getProfile(this.$store.state.URLHost, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.token
        }
      }, function (result) {
        if (result.response === true) {
          _this3.$store.state.user = result.data;
          _this3.$store.state.isLoading = false;
          // eslint-disable-next-line no-undef
          $('.preloader').fadeOut();
        } else {
          _this3.getProfile();
        }
      }, function (error) {
        _this3.alert_msg('error', 'Get Profile', 'Unable to retrieve user information because ' + error.message);
        _this3.OAuthToken();
      });
    },
    checkPermission: function checkPermission(roleId) {
      var _this4 = this;

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_8__models_service__["a" /* default */].checkPermiss(this.$store.state.URLHost, this.$route.meta.menu_id, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.token
        }
      }, function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(result.response === true)) {
                    _context3.next = 6;
                    break;
                  }

                  _context3.next = 3;
                  return _this4.getProfile();

                case 3:
                  if (result.data === false) {
                    _this4.defaultRoute(roleId);
                  } else {
                    _this4.$store.state.isLoading = false;
                  }
                  _context3.next = 9;
                  break;

                case 6:
                  _this4.alert_msg('warning', 'Check Permission', result.message);
                  _context3.next = 9;
                  return _this4.OAuthToken();

                case 9:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this4);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }(), function (error) {
        _this4.alert_msg('error', 'Check Permission', error.message);
        _this4.$router.push('/404');
      });
    },
    defaultRoute: function defaultRoute(roleId) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_8__models_service__["a" /* default */].getPermission(this.$store.state.URLHost, roleId, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.token
        }
      }, function (result) {
        if (result.response === true) {
          $('.preloader').fadeOut();
          try {
            result.data.forEach(function (v) {
              if (parseInt(v.is_active) === 1) {
                // this.alert_msg('warning', 'ตรวจสอบข้อมูล', 'คุณไม่มีสิทธิ์เข้าหน้านี้')
                _this5.$router.push(v.path);
                // eslint-disable-next-line no-undef
                throw BreakException;
              }
            });
          } catch (e) {
            // this.alert_msg('warning', 'ตรวจสอบข้อมูล', 'คุณไม่มีสิทธิ์เข้าหน้านี้')
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }, function (error) {
        _this5.alert_msg('error', 'Check Permission', error.message);
        // this.$router.push('/404')
      });
    },
    logOut: function logOut() {
      var _this6 = this;

      $('.preloader').fadeIn();
      var obj = {
        refresh_token: localStorage.refresh_token
      };
      __WEBPACK_IMPORTED_MODULE_8__models_service__["a" /* default */].Revoke(this.$store.state.URLHost, obj, function (result) {
        if (result.response === true) {
          localStorage.clear();
          sessionStorage.clear();
          _this6.$store.state.user = undefined;
          window.location.replace('/login');
          $('.preloader').fadeOut();
        } else {
          _this6.alert_msg('warning', 'Logout', result.message);
          localStorage.clear();
          sessionStorage.clear();
          _this6.$store.state.user = undefined;
          window.location.replace('/login');
          $('.preloader').fadeOut();
        }
      }, function (error) {
        if (error.message === 'Network Error') {
          _this6.alert_msg('error', 'Logout', 'Unable to login because ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error.message));
          localStorage.clear();
          sessionStorage.clear();
          _this6.$store.state.user = undefined;
          _this6.$router.push('/login');
          $('.preloader').fadeOut();
        } else {
          localStorage.clear();
          sessionStorage.clear();
          _this6.$store.state.user = undefined;
          window.location.replace('/login');
          $('.preloader').fadeOut();
        }
      });
    },
    dateTimeFormat: function dateTimeFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    timeFormatHHMM: function timeFormatHHMM(datetime) {
      return moment(datetime).format('HH:mm');
    },
    dmyFormat: function dmyFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    }
  }
});

$(document).on('show.bs.modal', '.modal', function () {
  var zIndex = 1040 + 10 * $('.modal:visible').length;
  $(this).css('z-index', zIndex);
  setTimeout(function () {
    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
  }, 0);
});

$(document).on('hidden.bs.modal', '.modal', function () {
  if ($('.modal.show').length > 0) {
    $('body').addClass('modal-open');
  }
});

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  Login: function Login(URL, obj, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'auth/login', obj).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  OAuth: function OAuth(URL, obj, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'auth/token', obj).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  QRcode: function QRcode(URL, obj, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'auth/qrcode', obj).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  Revoke: function Revoke(URL, obj, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'auth/revoke', obj).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getMenuList: function getMenuList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'menus', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getRole: function getRole(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'roles', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPermission: function getPermission(URL, roleID, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'permission/' + roleID, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkPermiss: function checkPermiss(URL, menuId, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'checkpermission/' + menuId, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  updateMenus: function updateMenus(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'permission', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getConfig: function getConfig(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'config', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getProfile: function getProfile(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'user/profile', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  updateProfile: function updateProfile(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'user/profile', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  changePass: function changePass(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'user/password', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function envBoolean(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (value === undefined || value === '') {
    return defaultValue;
  }

  return value === true || value === 'true' || value === '1';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  lastUpdate: "2026-07-05T15:10:00.547Z" || '',
  apiUrl: "https://api.agcaddy.com/" || '',
  uiUrl: "https://report.agcaddy.com" || '',
  keyPublic: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOiJkYWlzb19wb3MiLCJjcmVhdGUiOiIyMDIwLTEyLTE0IDEyOjQzOjEyIn0.1K9LjN4_hhOP4aOXqHJ3AZwqGS7ghomKA_SDd7S439k" || '',
  cloudfireSiteKey: "0x4AAAAAADhE8y1QKOiPAtoi" || '',
  cloudfireSecretKey: "0x4AAAAAADhE8xLUx3Xw1ZppEcOT_wq-zH4" || '',
  cloudfireEnabled: envBoolean("true"),
  titleWeb: "AGCADDY Inventory System" || '',
  descriptionWeb: "ระบบบริหารจัดการคลังสินค้าและวัสดุในโรงงานอุตสาหกรรม ที่รองรับการควบคุมสต็อก การติดตามการเคลื่อนไหวของวัสดุ การจัดการ Kanban และ 2-Bin การเชื่อมโยงข้อมูลกับสายการผลิต และการทำงานร่วมกับระบบ AGV เพื่อสนับสนุนการดำเนินงานตามแนวทาง Smart Factory และ Digital Manufacturing" || ''
});

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Vuex_index__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ant_design_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ant_design_vue_dist_antd_css__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ant_design_vue_dist_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ant_design_vue_dist_antd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_index_css__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_js_mixin__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_service__ = __webpack_require__(201);




var bootstrap = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var authenticated;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return restoreSession();

          case 2:
            authenticated = _context.sent;

            if (authenticated) {
              _context.next = 9;
              break;
            }

            localStorage.clear();
            sessionStorage.clear();

            if (!(window.location.pathname !== '/login')) {
              _context.next = 9;
              break;
            }

            window.location.replace('/login');
            return _context.abrupt('return');

          case 9:

            new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
              el: '#app',
              store: __WEBPACK_IMPORTED_MODULE_6__Vuex_index__["a" /* default */],
              router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
              template: '<App/>',
              render: function render(h) {
                return h(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]);
              }
            });

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function bootstrap() {
    return _ref.apply(this, arguments);
  };
}();











__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_ant_design_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;

function restoreSession() {
  if (sessionStorage.token || !localStorage.refresh_token || window.location.pathname === '/login') {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
  }

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_11__models_service__["a" /* default */].OAuth(__WEBPACK_IMPORTED_MODULE_6__Vuex_index__["a" /* default */].state.URLHost, { refresh_token: localStorage.refresh_token }, function (result) {
      if (result.response === true && result.data.access_token) {
        sessionStorage.token = result.data.access_token;
        resolve(true);
      } else {
        resolve(false);
      }
    }, function () {
      return resolve(false);
    });
  });
}

bootstrap();

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056e9654_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(558);
function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var normalizeComponent = __webpack_require__(510)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056e9654_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"preloader"},[_c('svg',{staticClass:"tea lds-ripple",attrs:{"width":"37","height":"48","viewbox":"0 0 37 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.0819 17H3.02508C1.91076 17 1.01376 17.9059 1.0485 19.0197C1.15761 22.5177 1.49703 29.7374 2.5 34C4.07125 40.6778 7.18553 44.8868 8.44856 46.3845C8.79051 46.79 9.29799 47 9.82843 47H20.0218C20.639 47 21.2193 46.7159 21.5659 46.2052C22.6765 44.5687 25.2312 40.4282 27.5 34C28.9757 29.8188 29.084 22.4043 29.0441 18.9156C29.0319 17.8436 28.1539 17 27.0819 17Z","stroke":"#2962FF","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M29 23.5C29 23.5 34.5 20.5 35.5 25.4999C36.0986 28.4926 34.2033 31.5383 32 32.8713C29.4555 34.4108 28 34 28 34","stroke":"#2962FF","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"teabag","fill":"#2962FF","fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 25V17H14V25H12C10.3431 25 9 26.3431 9 28V34C9 35.6569 10.3431 37 12 37H18C19.6569 37 21 35.6569 21 34V28C21 26.3431 19.6569 25 18 25H16ZM11 28C11 27.4477 11.4477 27 12 27H18C18.5523 27 19 27.4477 19 28V34C19 34.5523 18.5523 35 18 35H12C11.4477 35 11 34.5523 11 34V28Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"steamL","d":"M17 1C17 1 17 4.5 14 6.5C11 8.5 11 12 11 12","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#2962FF"}}),_vm._v(" "),_c('path',{attrs:{"id":"steamR","d":"M21 6C21 6 21 8.22727 19 9.5C17 10.7727 17 13 17 13","stroke":"#2962FF","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(560);



var main = function main() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1044));
};

// group_id: '1'
var dashboard = function dashboard() {
  return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1045));
};
// group_id: '2'
var supplier = function supplier() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1046));
};
var dock = function dock() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1047));
};
var unit = function unit() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1048));
};
var item = function item() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1049));
};
var locationLink = function locationLink() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1050));
};
var truckType = function truckType() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1051));
};
var truck = function truck() {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1052));
};
var truckDetail = function truckDetail() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1053));
};
var truckPattern = function truckPattern() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1054));
};
var cycle = function cycle() {
  return __webpack_require__.e/* import() */(116).then(__webpack_require__.bind(null, 1055));
};
var cycleDetail = function cycleDetail() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1056));
};
var dayoff = function dayoff() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1057));
};
// group_id: '3'
var receive = function receive() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1058));
};
var receiveOrder = function receiveOrder() {
  return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 1059));
};
var receiveOrderConfirm = function receiveOrderConfirm() {
  return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 1060));
};
var receiveEdit = function receiveEdit() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1061));
};
var receiveOrderEdit = function receiveOrderEdit() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1062));
};
var receiveOrderList = function receiveOrderList() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1063));
};
var receiveOrderConfirmEdit = function receiveOrderConfirmEdit() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1064));
};
var issue = function issue() {
  return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, 1065));
};
var issueAdd = function issueAdd() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1066));
};
var issueEdit = function issueEdit() {
  return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1067));
};
var inspect = function inspect() {
  return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 1068));
};
var inspectAdd = function inspectAdd() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1069));
};
var inspectEdit = function inspectEdit() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1070));
};
var orderRelease = function orderRelease() {
  return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 1071));
};
var orderReleaseCheck = function orderReleaseCheck() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1072));
};
var orderPlan = function orderPlan() {
  return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 1073));
};
var orderPlanUpload = function orderPlanUpload() {
  return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1074));
};
var confirmOrder = function confirmOrder() {
  return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, 1075));
};
var orderDetail = function orderDetail() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1076));
};
var deliveryPlan = function deliveryPlan() {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1077));
};
var suffixSearch = function suffixSearch() {
  return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1078));
};
var kanbanSuffix = function kanbanSuffix() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1079));
};
// group_id: '4'
var adjust = function adjust() {
  return __webpack_require__.e/* import() */(118).then(__webpack_require__.bind(null, 1080));
};
var adjustAdd = function adjustAdd() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1081));
};
var kanbanAdjust = function kanbanAdjust() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1082));
};
var kanbanAdjustManage = function kanbanAdjustManage() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1083));
};
var kanbanAdjustDayoffUpload = function kanbanAdjustDayoffUpload() {
  return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1084));
};
var kanbanAdjustFactorUpload = function kanbanAdjustFactorUpload() {
  return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1085));
};
var prodSafetyFactor = function prodSafetyFactor() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1086));
};
var mrpCal = function mrpCal() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1087));
};
// group_id: '5'
var reportPartLinkage = function reportPartLinkage() {
  return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1088));
};
var reportAllPartSerial = function reportAllPartSerial() {
  return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 1089));
};
var reportStockTracking = function reportStockTracking() {
  return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1090));
};
var reportInspect = function reportInspect() {
  return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 1091));
};
var reportReceive = function reportReceive() {
  return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1092));
};
var reportReceiveOrder = function reportReceiveOrder() {
  return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1093));
};
var reportIssue = function reportIssue() {
  return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 1094));
};
var reportStockShelfTracking = function reportStockShelfTracking() {
  return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1095));
};
var reportSummaryByPart = function reportSummaryByPart() {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1096));
};
var reportStockDetailByShelf = function reportStockDetailByShelf() {
  return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1097));
};
var reportStockHistory = function reportStockHistory() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1098));
};
var reportAdjust = function reportAdjust() {
  return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 1099));
};
var reportKanban = function reportKanban() {
  return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 1100));
};
var reportKanbanSuffix = function reportKanbanSuffix() {
  return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 1101));
};
var reportTruckMaster = function reportTruckMaster() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1102));
};
var reportMaxMin = function reportMaxMin() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1103));
};
// group_id: '6'
var calendarPattern = function calendarPattern() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1104));
};
var config = function config() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1105));
};
var user = function user() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1106));
};
var permission = function permission() {
  return __webpack_require__.e/* import() */(120).then(__webpack_require__.bind(null, 1107));
};
// group_id: '7'
var logLogin = function logLogin() {
  return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 1108));
};
var logConfig = function logConfig() {
  return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 1109));
};
var logAdjust = function logAdjust() {
  return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 1110));
};
var logCalendar = function logCalendar() {
  return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 1111));
};
var logDock = function logDock() {
  return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 1112));
};
var logInspect = function logInspect() {
  return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 1113));
};
var logIssue = function logIssue() {
  return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 1114));
};
var logLocationLinkage = function logLocationLinkage() {
  return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 1115));
};
var logPart = function logPart() {
  return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 1116));
};
var logPartStore = function logPartStore() {
  return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 1117));
};
var logReceive = function logReceive() {
  return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 1118));
};
var logSupplier = function logSupplier() {
  return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 1119));
};
var logUser = function logUser() {
  return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 1120));
};
var logPsf = function logPsf() {
  return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 1121));
};
var logMrp = function logMrp() {
  return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 1122));
};
var logKanbanAdjust = function logKanbanAdjust() {
  return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 1123));
};
var logFifo = function logFifo() {
  return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 1124));
};
// group_id: '8'
var scanRoutine = function scanRoutine() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1125));
};
var scanPhysical = function scanPhysical() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1126));
};
var packaging = function packaging() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1127));
};
var packagingNonMovement = function packagingNonMovement() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1128));
};
var scanReport = function scanReport() {
  return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1129));
};
var writeOffReport = function writeOffReport() {
  return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1130));
};
var writeOffInput = function writeOffInput() {
  return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1131));
};
var scanWriteoff = function scanWriteoff() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1132));
};
var scanReborn = function scanReborn() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1133));
};
var manualWriteoff = function manualWriteoff() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1134));
};
var manualReborn = function manualReborn() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1135));
};
// group_id: '9'
var packingstockout = function packingstockout() {
  return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 1136));
};
var packingstockoutAdd = function packingstockoutAdd() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1137));
};
var packingstockoutEdit = function packingstockoutEdit() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1138));
};
var packingList = function packingList() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1139));
};
var packingtwobinAdd = function packingtwobinAdd() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1140));
};
var packingpassthroughAdd = function packingpassthroughAdd() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1141));
};
var packingtwobinDetail = function packingtwobinDetail() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1142));
};
var packingpassthroughDetail = function packingpassthroughDetail() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1143));
};
var packingservicepartDetail = function packingservicepartDetail() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1144));
};
var packingservicepartAdd = function packingservicepartAdd() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1145));
};
var packingbox = function packingbox() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1146));
};
var packingstore = function packingstore() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1147));
};
var packingPlan = function packingPlan() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1148));
};
var dummy = function dummy() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1149));
};
// group_id: '10'
var reportPackingStockBalance = function reportPackingStockBalance() {
  return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1150));
};
var reportPackingSerial = function reportPackingSerial() {
  return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1151));
};
var reportPackingStock = function reportPackingStock() {
  return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1152));
};
var reportPacking = function reportPacking() {
  return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1153));
};
// group_id: '11'
var agvSetup = function agvSetup() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1154));
};
var agvSetupImport = function agvSetupImport() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1155));
};
var agvVehicle = function agvVehicle() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1156));
};
var agvOrder = function agvOrder() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1157));
};
var agvOrderList = function agvOrderList() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1158));
};
var agvReceive = function agvReceive() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1159));
};
var agvShop = function agvShop() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1160));
};
var agvLog = function agvLog() {
  return __webpack_require__.e/* import() */(122).then(__webpack_require__.bind(null, 1161));
};
var agvBoard = function agvBoard() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1162));
};
var agvOrderReport = function agvOrderReport() {
  return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1163));
};
// group_id: ''
var login = function login() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1164));
};
var wait = function wait() {
  return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, 1165));
};
var error404 = function error404() {
  return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, 1166));
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var titlename = ' | AGcaddy';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'wait',
    component: wait,
    meta: { title: 'Waiting', title_sub: '', group_id: 0, menu_id: 0 }
  }, {
    path: '',
    name: 'main',
    component: main,
    children: [
    // group_id: '1'
    {
      path: '/dashboard',
      name: 'dashboard',
      component: dashboard,
      meta: { title: 'Dashboard', title_sub: '', group_id: '1', menu_id: '1' }
    },
    // group_id: '2'
    {
      path: '/supplier',
      name: 'supplier',
      component: supplier,
      meta: { title: 'Supplier', title_sub: '', group_id: '2', menu_id: '19' }
    }, {
      path: '/dock',
      name: 'dock',
      component: dock,
      meta: { title: 'Dock', title_sub: '', group_id: '2', menu_id: '20' }
    }, {
      path: '/unit',
      name: 'unit',
      component: unit,
      meta: { title: 'Unit', title_sub: '', group_id: '2', menu_id: '3' }
    }, {
      path: '/item',
      name: 'item',
      component: item,
      meta: { title: 'Part', title_sub: '', group_id: '2', menu_id: '2' }
    }, {
      path: '/locationlink',
      name: 'locationLink',
      component: locationLink,
      meta: { title: 'Shelf Location', title_sub: '', group_id: '2', menu_id: '21' }
    }, {
      path: '/trucktype',
      name: 'truckType',
      component: truckType,
      meta: { title: 'Truck Type', title_sub: '', group_id: '2', menu_id: '54' }
    }, {
      path: '/truck',
      name: 'truck',
      component: truck,
      meta: { title: 'Truck Master', title_sub: '', group_id: '2', menu_id: '8' }
    }, {
      path: '/truckdetail',
      name: 'truckDetail',
      component: truckDetail,
      meta: { title: 'Truck Pattern', title_sub: '', group_id: '2', menu_id: '8' }
    }, {
      path: '/truckpattern',
      name: 'truckPattern',
      component: truckPattern,
      meta: { title: 'Truck Calendar', title_sub: '', group_id: '2', menu_id: '8' }
    }, {
      path: '/cycle',
      name: 'cycle',
      component: cycle,
      meta: { title: 'Cycle Registration', title_sub: '', group_id: '2', menu_id: '28' }
    }, {
      path: '/cycledetail',
      name: 'cycleDetail',
      component: cycleDetail,
      meta: { title: 'Cycle Registration', title_sub: '', group_id: '2', menu_id: '28' }
    }, {
      path: '/dayoff',
      name: 'dayoff',
      component: dayoff,
      meta: { title: 'Calendar', title_sub: '', group_id: '2', menu_id: '46' }
    },
    // group_id: '3'
    {
      path: '/receive',
      name: 'receive',
      component: receive,
      meta: { title: 'Stock In', title_sub: '', group_id: '3', menu_id: '4' }
    }, {
      path: '/receiveorder',
      name: 'receiveOrder',
      component: receiveOrder,
      meta: { title: 'Stock In Order', title_sub: '', group_id: '3', menu_id: '60' }
    }, {
      path: '/receiveorderconfirm',
      name: 'receiveOrderConfirm',
      component: receiveOrderConfirm,
      meta: { title: 'Stock In Confirm', title_sub: '', group_id: '3', menu_id: '62' }
    }, {
      path: '/receiveedit',
      name: 'receiveEdit',
      component: receiveEdit,
      meta: { title: 'Stock In Edit', title_sub: '', group_id: '3', menu_id: '4' }
    }, {
      path: '/receiveorderedit',
      name: 'receiveOrderEdit',
      component: receiveOrderEdit,
      meta: { title: 'Stock In Order Edit', title_sub: '', group_id: '3', menu_id: '60' }
    }, {
      path: '/receiveorderconfirmedit',
      name: 'receiveOrderConfirmEdit',
      component: receiveOrderConfirmEdit,
      meta: { title: 'Stock In Confirm Edit', title_sub: '', group_id: '3', menu_id: '62' }
    }, {
      path: '/receiveorderlist',
      name: 'receiveOrderList',
      component: receiveOrderList,
      meta: { title: 'Stock In Order List', title_sub: '', group_id: '3', menu_id: '60' }
    }, {
      path: '/issue',
      name: 'issue',
      component: issue,
      meta: { title: 'Stock Out', title_sub: '', group_id: '3', menu_id: '5' }
    }, {
      path: '/issueadd',
      name: 'issueAdd',
      component: issueAdd,
      meta: { title: 'Add Stock Out', title_sub: '', group_id: '3', menu_id: '5' }
    }, {
      path: '/issueedit',
      name: 'issueEdit',
      component: issueEdit,
      meta: { title: 'Edit Stock Out', title_sub: '', group_id: '3', menu_id: '5' }
    }, {
      path: '/inspect',
      name: 'inspect',
      component: inspect,
      meta: { title: 'Stock Taking', title_sub: '', group_id: '3', menu_id: '6' }
    }, {
      path: '/inspectadd',
      name: 'inspectAdd',
      component: inspectAdd,
      meta: { title: 'Stock Taking Add', title_sub: '', group_id: '3', menu_id: '6' }
    }, {
      path: '/inspect/:id',
      name: 'inspectEdit',
      component: inspectEdit,
      meta: { title: 'Stock Taking Edit', title_sub: '', group_id: '3', menu_id: '6' }
    }, {
      path: '/orderrelease',
      name: 'orderRelease',
      component: orderRelease,
      meta: { title: 'Order Release', title_sub: '', group_id: '3', menu_id: '53' }
    }, {
      path: '/orderreleasecheck',
      name: 'orderReleaseCheck',
      component: orderReleaseCheck,
      meta: { title: 'Order Release Check', title_sub: '', group_id: '3', menu_id: '53' }
    }, {
      path: '/orderplan',
      name: 'orderPlan',
      component: orderPlan,
      meta: { title: 'Order Plan', title_sub: '', group_id: '3', menu_id: '66' }
    }, {
      path: '/orderplanupload',
      name: 'orderPlanUpload',
      component: orderPlanUpload,
      meta: { title: 'Order Plan Upload', title_sub: '', group_id: '3', menu_id: '66' }
    }, {
      path: '/suffixsearch',
      name: 'suffixSearch',
      component: suffixSearch,
      meta: { title: 'Kanban Suffix Search', title_sub: '', group_id: '3', menu_id: '64' }
    }, {
      path: '/kanbansuffix',
      name: 'kanbanSuffix',
      component: kanbanSuffix,
      meta: { title: 'Kanban Suffix Search', title_sub: '', group_id: '3', menu_id: '64' }
    }, {
      path: '/confirmorder',
      name: 'confirmOrder',
      component: confirmOrder,
      meta: { title: 'Confirmation Order', title_sub: '', group_id: '3', menu_id: '55' }
    }, {
      path: '/orderdetail',
      name: 'orderDetail',
      component: orderDetail,
      meta: { title: 'Order Detail', title_sub: '', group_id: '3', menu_id: '55' }
    }, {
      path: '/deliveryplan',
      name: 'deliveryPlan',
      component: deliveryPlan,
      meta: { title: 'Delivery Plan', title_sub: '', group_id: '3', menu_id: '55' }
    },
    // group_id: '4'
    {
      path: '/adjust',
      name: 'adjust',
      component: adjust,
      meta: { title: 'Adjust Stock', title_sub: '', group_id: '4', menu_id: '7' }
    }, {
      path: '/adjustadd',
      name: 'adjustAdd',
      component: adjustAdd,
      meta: { title: 'Add Adjust Stock', title_sub: '', group_id: '4', menu_id: '7' }
    }, {
      path: '/kanbanadjust',
      name: 'kanbanAdjust',
      component: kanbanAdjust,
      meta: { title: 'Kanban Adjust', title_sub: '', group_id: '4', menu_id: '56' }
    }, {
      path: '/kanbanadjustmanage/:ps_id',
      name: 'kanbanAdjustManage',
      component: kanbanAdjustManage,
      meta: { title: 'Kanban Adjust Manage', title_sub: '', group_id: '4', menu_id: '56' }
    }, {
      path: '/kanbanadjustdayoffupload',
      name: 'kanbanAdjustDayoffUpload',
      component: kanbanAdjustDayoffUpload,
      meta: { title: 'Kanban Adjust Dayoff Upload', title_sub: '', group_id: '4', menu_id: '56' }
    }, {
      path: '/kanbanadjustfactorupload',
      name: 'kanbanAdjustFactorUpload',
      component: kanbanAdjustFactorUpload,
      meta: { title: 'Kanban Adjust Factor Upload', title_sub: '', group_id: '4', menu_id: '56' }
    }, {
      path: '/prodsafetyfactor',
      name: 'prodSafetyFactor',
      component: prodSafetyFactor,
      meta: { title: 'Prod & Safety Factor', title_sub: '', group_id: '4', menu_id: '29' }
    }, {
      path: '/mrp',
      name: 'mrpCal',
      component: mrpCal,
      meta: { title: 'MRP Cal', title_sub: '', group_id: '4', menu_id: '30' }
    },
    // group_id: '5'
    {
      path: '/reportreceive',
      name: 'reportReceive',
      component: reportReceive,
      meta: { title: 'Report Stock In', title_sub: '', group_id: '5', menu_id: '9' }
    }, {
      path: '/reportreceiveorder',
      name: 'reportReceiveOrder',
      component: reportReceiveOrder,
      meta: { title: 'Report Stock In Order', title_sub: '', group_id: '5', menu_id: '61' }
    }, {
      path: '/reportissue',
      name: 'reportIssue',
      component: reportIssue,
      meta: { title: 'Report Stock Out', title_sub: '', group_id: '5', menu_id: '10' }
    }, {
      path: '/reportinspect',
      name: 'reportInspect',
      component: reportInspect,
      meta: { title: 'Report Inspect', title_sub: '', group_id: '5', menu_id: '11' }
    }, {
      path: '/reportpartlinkage',
      name: 'reportPartLinkage',
      component: reportPartLinkage,
      meta: { title: 'Report Part Linkage', title_sub: '', group_id: '5', menu_id: '22' }
    }, {
      path: '/reportallpartserial',
      name: 'reportAllPartSerial',
      component: reportAllPartSerial,
      meta: { title: 'Report Serial', title_sub: '', group_id: '5', menu_id: '59' }
    }, {
      path: '/reportstocktracking',
      name: 'reportStockTracking',
      component: reportStockTracking,
      meta: { title: 'Report Balance Stock', title_sub: '', group_id: '5', menu_id: '23' }
    }, {
      path: '/reportstockshelftracking',
      name: 'reportStockShelfTracking',
      component: reportStockShelfTracking,
      meta: { title: 'Report Balance Stock', title_sub: '', group_id: '5', menu_id: '24' }
    }, {
      path: '/reportstockhistory',
      name: 'reportStockHistory',
      component: reportStockHistory,
      meta: { title: 'Report History Stock Taking By Part', title_sub: '', group_id: '5', menu_id: '25' }
    }, {
      path: '/reportsummarybypart',
      name: 'reportSummaryByPart',
      component: reportSummaryByPart,
      meta: { title: 'Report Summary By Part', title_sub: '', group_id: '5', menu_id: '26' }
    }, {
      path: '/reportstockdetailbyshelf',
      name: 'reportStockDetailByShelf',
      component: reportStockDetailByShelf,
      meta: { title: 'Report Stock Detail By Shelf', title_sub: '', group_id: '5', menu_id: '27' }
    }, {
      path: '/reporttruckmaster',
      name: 'reportTruckMaster',
      component: reportTruckMaster,
      meta: { title: 'Report Truck Master', title_sub: '', group_id: '5', menu_id: '52' }
    }, {
      path: '/reportmaxmin',
      name: 'reportMaxMin',
      component: reportMaxMin,
      meta: { title: 'Report Kanban Setup', title_sub: '', group_id: '5', menu_id: '32' }
    }, {
      path: '/reportadjust',
      name: 'reportAdjust',
      component: reportAdjust,
      meta: { title: 'Report Adjust', title_sub: '', group_id: '5', menu_id: '12' }
    }, {
      path: '/reportkanban',
      name: 'reportKanban',
      component: reportKanban,
      meta: { title: 'Report Kanban Adjust', title_sub: '', group_id: '5', menu_id: '57' }
    }, {
      path: '/reportkanbansuffix',
      name: 'reportKanbanSuffix',
      component: reportKanbanSuffix,
      meta: { title: 'Report Kanban Suffix', title_sub: '', group_id: '5', menu_id: '65' }
    },
    // group_id: '6'
    {
      path: '/calendarpattern',
      name: 'calendarPattern',
      component: calendarPattern,
      meta: { title: 'Calendar Pattern', title_sub: '', group_id: '6', menu_id: '47' }
    }, {
      path: '/config',
      name: 'config',
      component: config,
      meta: { title: 'Config', title_sub: '', group_id: '6', menu_id: '14' }
    }, {
      path: '/user',
      name: 'user',
      component: user,
      meta: { title: 'User', title_sub: '', group_id: '6', menu_id: '15' }
    }, {
      path: '/permission',
      name: 'permission',
      component: permission,
      meta: { title: 'Permission', title_sub: '', group_id: '6', menu_id: '16' }
    },
    // group_id: '7'
    {
      path: '/loglogin',
      name: 'logLogin',
      component: logLogin,
      meta: { title: 'Log Login', title_sub: '', group_id: '7', menu_id: '17' }
    }, {
      path: '/logconfig',
      name: 'logConfig',
      component: logConfig,
      meta: { title: 'Log Config', title_sub: '', group_id: '7', menu_id: '18' }
    }, {
      path: '/loguser',
      name: 'logUser',
      component: logUser,
      meta: { title: 'Log User', title_sub: '', group_id: '7', menu_id: '43' }
    }, {
      path: '/logadjust',
      name: 'logAdjust',
      component: logAdjust,
      meta: { title: 'Log Adjust', title_sub: '', group_id: '7', menu_id: '33' }
    }, {
      path: '/logcalendar',
      name: 'logCalendar',
      component: logCalendar,
      meta: { title: 'Log Calendar', title_sub: '', group_id: '7', menu_id: '34' }
    }, {
      path: '/logdock',
      name: 'logDock',
      component: logDock,
      meta: { title: 'Log Dock', title_sub: '', group_id: '7', menu_id: '35' }
    }, {
      path: '/loginspect',
      name: 'logInspect',
      component: logInspect,
      meta: { title: 'Log Inspect', title_sub: '', group_id: '7', menu_id: '36' }
    }, {
      path: '/logissue',
      name: 'logIssue',
      component: logIssue,
      meta: { title: 'Log Issue', title_sub: '', group_id: '7', menu_id: '37' }
    }, {
      path: '/loglocationlinkage',
      name: 'logLocationLinkage',
      component: logLocationLinkage,
      meta: { title: 'Log Location Linkage', title_sub: '', group_id: '7', menu_id: '38' }
    }, {
      path: '/logpart',
      name: 'logPart',
      component: logPart,
      meta: { title: 'Log Part', title_sub: '', group_id: '7', menu_id: '39' }
    }, {
      path: '/logpartstore',
      name: 'logPartStore',
      component: logPartStore,
      meta: { title: 'Log Part Store', title_sub: '', group_id: '7', menu_id: '40' }
    }, {
      path: '/logreceive',
      name: 'logReceive',
      component: logReceive,
      meta: { title: 'Log Receive', title_sub: '', group_id: '7', menu_id: '41' }
    }, {
      path: '/logsupplier',
      name: 'logSupplier',
      component: logSupplier,
      meta: { title: 'Log Supplier', title_sub: '', group_id: '7', menu_id: '42' }
    }, {
      path: '/logpsf',
      name: 'logPsf',
      component: logPsf,
      meta: { title: 'Log Prod & Safety Factor', title_sub: '', group_id: '7', menu_id: '50' }
    }, {
      path: '/logmrp',
      name: 'logMrp',
      component: logMrp,
      meta: { title: 'Log MRP Cal', title_sub: '', group_id: '7', menu_id: '51' }
    }, {
      path: '/logkanbanadjust',
      name: 'logKanbanAdjust',
      component: logKanbanAdjust,
      meta: { title: 'Log Kanban Adjust', title_sub: '', group_id: '7', menu_id: '58' }
    }, {
      path: '/logfifo',
      name: 'logFifo',
      component: logFifo,
      meta: { title: 'Log FIFO Override', title_sub: '', group_id: '7', menu_id: '73' }
    },
    // group_id: '8'
    {
      path: '/scanroutine',
      name: 'scanRoutine',
      component: scanRoutine,
      meta: { title: 'Packaging', title_sub: 'Routine Scanning', group_id: '8', menu_id: '68' }
    }, {
      path: '/scanphysical',
      name: 'scanPhysical',
      component: scanPhysical,
      meta: { title: 'Packaging', title_sub: 'Physical Scanning', group_id: '8', menu_id: '69' }
    }, {
      path: '/packaging',
      name: 'packaging',
      component: packaging,
      meta: { title: 'Packaging', title_sub: 'Packaging List Master', group_id: '8', menu_id: '67' }
    }, {
      path: '/nonmovement',
      name: 'nonMovement',
      component: packagingNonMovement,
      meta: { title: 'Packaging', title_sub: 'Non Movement Alert', group_id: '8', menu_id: '70' }
    }, {
      path: '/scanreport',
      name: 'scanReport',
      component: scanReport,
      meta: { title: 'Packaging', title_sub: 'Scanning Result Report', group_id: '8', menu_id: '71' }
    }, {
      path: '/writeoffreport',
      name: 'writeOffReport',
      component: writeOffReport,
      meta: { title: 'Packaging', title_sub: 'Write Off Report', group_id: '8', menu_id: '72' }
    }, {
      path: '/writeoffinput',
      name: 'writeOffInput',
      component: writeOffInput,
      meta: { title: 'Packaging', title_sub: 'Write Off Input', group_id: '8', menu_id: '74' }
    }, {
      path: '/scanwriteoff',
      name: 'scanWriteoff',
      component: scanWriteoff,
      meta: { title: 'Packaging', title_sub: 'Scanning Write-Off', group_id: '8', menu_id: '74' }
    }, {
      path: '/scanreborn',
      name: 'scanReborn',
      component: scanReborn,
      meta: { title: 'Packaging', title_sub: 'Scanning Reborn', group_id: '8', menu_id: '74' }
    }, {
      path: '/manualwriteoff',
      name: 'manualWriteoff',
      component: manualWriteoff,
      meta: { title: 'Packaging', title_sub: 'Manual Write-Off', group_id: '8', menu_id: '74' }
    }, {
      path: '/manualreborn',
      name: 'manualReborn',
      component: manualReborn,
      meta: { title: 'Packaging', title_sub: 'Manual Reborn', group_id: '8', menu_id: '74' }
    },
    // group_id: '9'
    {
      path: '/packingstockout',
      name: 'packingstockout',
      component: packingstockout,
      meta: { title: 'Packing Stock Out', title_sub: '', group_id: '9', menu_id: '79' }
    }, {
      path: '/packingstockoutadd',
      name: 'packingstockoutAdd',
      component: packingstockoutAdd,
      meta: { title: 'Add Packing Stock Out', title_sub: '', group_id: '9', menu_id: '79' }
    }, {
      path: '/packingstockoutedit',
      name: 'packingstockoutEdit',
      component: packingstockoutEdit,
      meta: { title: 'Edit Packing Stock Out', title_sub: '', group_id: '9', menu_id: '79' }
    }, {
      path: '/packinglist',
      name: 'packingList',
      component: packingList,
      meta: { title: 'Packing List', title_sub: '', group_id: '9', menu_id: '77' }
    }, {
      path: '/packingtwobinadd',
      name: 'packingtwobinAdd',
      component: packingtwobinAdd,
      meta: { title: 'Add Packing 2Bin', title_sub: '', group_id: '9', menu_id: '76' }
    }, {
      path: '/packingpassthroughadd',
      name: 'packingpassthroughAdd',
      component: packingpassthroughAdd,
      meta: { title: 'Add Packing Pass Through', title_sub: '', group_id: '9', menu_id: '84' }
    }, {
      path: '/packingservicepartadd',
      name: 'packingservicepartAdd',
      component: packingservicepartAdd,
      meta: { title: 'Add Packing Service Part', title_sub: '', group_id: '9', menu_id: '78' }
    }, {
      path: '/packingtwobindetail/:pk_id',
      name: 'packingtwobinDetail',
      component: packingtwobinDetail,
      meta: { title: 'Packing Detail', title_sub: '', group_id: '9', menu_id: '76' }
    }, {
      path: '/packingpassthroughdetail/:pk_id',
      name: 'packingpassthroughDetail',
      component: packingpassthroughDetail,
      meta: { title: 'Packing Detail', title_sub: '', group_id: '9', menu_id: '84' }
    }, {
      path: '/packingservicepartdetail/:pk_id',
      name: 'packingservicepartDetail',
      component: packingservicepartDetail,
      meta: { title: 'Packing Detail', title_sub: '', group_id: '9', menu_id: '78' }
    }, {
      path: '/packingbox',
      name: 'packingbox',
      component: packingbox,
      meta: { title: 'Packing Box List', title_sub: '', group_id: '9', menu_id: '80' }
    }, {
      path: '/packingstore',
      name: 'packingstore',
      component: packingstore,
      meta: { title: 'Packing List Master', title_sub: '', group_id: '9', menu_id: '75' }
    }, {
      path: '/dummy',
      name: 'Dummy Serial',
      component: dummy,
      meta: { title: 'Dummy Serial', title_sub: '', group_id: '9', menu_id: '75' }
    }, {
      path: '/packingplan',
      name: 'packingplan',
      component: packingPlan,
      meta: { title: 'Packing Plan', title_sub: '', group_id: '9', menu_id: '95' }
    },
    // group_id: '10'
    {
      path: '/reportpackingstockbalance',
      name: 'reportpackingstockbalance',
      component: reportPackingStockBalance,
      meta: { title: 'Report Packing Stock Balance', title_sub: '', group_id: '10', menu_id: '81' }
    }, {
      path: '/reportpackingserial',
      name: 'reportpackingserial',
      component: reportPackingSerial,
      meta: { title: 'Report Packing Serial', title_sub: '', group_id: '10', menu_id: '82' }
    }, {
      path: '/reportpackingstock',
      name: 'reportpackingstock',
      component: reportPackingStock,
      meta: { title: 'Report Packing Stock', title_sub: '', group_id: '10', menu_id: '83' }
    }, {
      path: '/reportpacking',
      name: 'reportpacking',
      component: reportPacking,
      meta: { title: 'Report Packing', title_sub: '', group_id: '10', menu_id: '85' }
    },
    // group_id: '11'
    {
      path: '/agvsetup',
      name: 'agvSetup',
      component: agvSetup,
      meta: { title: 'AGV Setup', title_sub: '', group_id: '11', menu_id: '92' }
    }, {
      path: '/agvsetupimport',
      name: 'agvsetupimport',
      component: agvSetupImport,
      meta: { title: 'AGV Setup Import', title_sub: '', group_id: '11', menu_id: '94' }
    }, {
      path: '/agvvehicle',
      name: 'agvVehicle',
      component: agvVehicle,
      meta: { title: 'AGV Vehicle', title_sub: '', group_id: '11', menu_id: '86' }
    }, {
      path: '/agvorder',
      name: 'agvOrder',
      component: agvOrder,
      meta: { title: 'AGV Order', title_sub: '', group_id: '11', menu_id: '87' }
    }, {
      path: '/agvorderlist',
      name: 'agvOrderList',
      component: agvOrderList,
      meta: { title: 'AGV Order List', title_sub: '', group_id: '11', menu_id: '87' }
    }, {
      path: '/agvreceive',
      name: 'agvReceive',
      component: agvReceive,
      meta: { title: 'AGV Receive', title_sub: '', group_id: '11', menu_id: '87' }
    }, {
      path: '/agvshop',
      name: 'agvShop',
      component: agvShop,
      meta: { title: 'AGV Shop', title_sub: '', group_id: '11', menu_id: '88' }
    }, {
      path: '/agvlog',
      name: 'agvLog',
      component: agvLog,
      meta: { title: 'AGV Log', title_sub: '', group_id: '11', menu_id: '89' }
    }, {
      path: '/agvboard',
      name: 'agvBoard',
      component: agvBoard,
      meta: { title: 'AGV Board', title_sub: '', group_id: '11', menu_id: '91' }
    }, {
      path: '/agvorderreport',
      name: 'agvOrderReport',
      component: agvOrderReport,
      meta: { title: 'AGV Order Report', title_sub: '', group_id: '11', menu_id: '93' }
    }]
  }, {
    path: '/login',
    name: 'login',
    component: login,
    meta: { title: 'Login', title_sub: '' }
  }, {
    path: '*',
    name: 'P404',
    component: error404,
    meta: { title: 'Error Page', title_sub: '' }
  }]
});
var DEFAULT_TITLE = titlename;
router.afterEach(function (to, from) {
  document.title = to.meta.title !== '' ? to.meta.title + titlename : to.meta.title_sub + titlename || DEFAULT_TITLE + titlename;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 222,
	"./af.js": 222,
	"./ar": 223,
	"./ar-dz": 224,
	"./ar-dz.js": 224,
	"./ar-kw": 225,
	"./ar-kw.js": 225,
	"./ar-ly": 226,
	"./ar-ly.js": 226,
	"./ar-ma": 227,
	"./ar-ma.js": 227,
	"./ar-sa": 228,
	"./ar-sa.js": 228,
	"./ar-tn": 229,
	"./ar-tn.js": 229,
	"./ar.js": 223,
	"./az": 230,
	"./az.js": 230,
	"./be": 231,
	"./be.js": 231,
	"./bg": 232,
	"./bg.js": 232,
	"./bm": 233,
	"./bm.js": 233,
	"./bn": 234,
	"./bn-bd": 235,
	"./bn-bd.js": 235,
	"./bn.js": 234,
	"./bo": 236,
	"./bo.js": 236,
	"./br": 237,
	"./br.js": 237,
	"./bs": 238,
	"./bs.js": 238,
	"./ca": 239,
	"./ca.js": 239,
	"./cs": 240,
	"./cs.js": 240,
	"./cv": 241,
	"./cv.js": 241,
	"./cy": 242,
	"./cy.js": 242,
	"./da": 243,
	"./da.js": 243,
	"./de": 244,
	"./de-at": 245,
	"./de-at.js": 245,
	"./de-ch": 246,
	"./de-ch.js": 246,
	"./de.js": 244,
	"./dv": 247,
	"./dv.js": 247,
	"./el": 248,
	"./el.js": 248,
	"./en-au": 249,
	"./en-au.js": 249,
	"./en-ca": 250,
	"./en-ca.js": 250,
	"./en-gb": 251,
	"./en-gb.js": 251,
	"./en-ie": 252,
	"./en-ie.js": 252,
	"./en-il": 253,
	"./en-il.js": 253,
	"./en-in": 254,
	"./en-in.js": 254,
	"./en-nz": 255,
	"./en-nz.js": 255,
	"./en-sg": 256,
	"./en-sg.js": 256,
	"./eo": 257,
	"./eo.js": 257,
	"./es": 258,
	"./es-do": 259,
	"./es-do.js": 259,
	"./es-mx": 260,
	"./es-mx.js": 260,
	"./es-us": 261,
	"./es-us.js": 261,
	"./es.js": 258,
	"./et": 262,
	"./et.js": 262,
	"./eu": 263,
	"./eu.js": 263,
	"./fa": 264,
	"./fa.js": 264,
	"./fi": 265,
	"./fi.js": 265,
	"./fil": 266,
	"./fil.js": 266,
	"./fo": 267,
	"./fo.js": 267,
	"./fr": 268,
	"./fr-ca": 269,
	"./fr-ca.js": 269,
	"./fr-ch": 270,
	"./fr-ch.js": 270,
	"./fr.js": 268,
	"./fy": 271,
	"./fy.js": 271,
	"./ga": 272,
	"./ga.js": 272,
	"./gd": 273,
	"./gd.js": 273,
	"./gl": 274,
	"./gl.js": 274,
	"./gom-deva": 275,
	"./gom-deva.js": 275,
	"./gom-latn": 276,
	"./gom-latn.js": 276,
	"./gu": 277,
	"./gu.js": 277,
	"./he": 278,
	"./he.js": 278,
	"./hi": 279,
	"./hi.js": 279,
	"./hr": 280,
	"./hr.js": 280,
	"./hu": 281,
	"./hu.js": 281,
	"./hy-am": 282,
	"./hy-am.js": 282,
	"./id": 283,
	"./id.js": 283,
	"./is": 284,
	"./is.js": 284,
	"./it": 285,
	"./it-ch": 286,
	"./it-ch.js": 286,
	"./it.js": 285,
	"./ja": 287,
	"./ja.js": 287,
	"./jv": 288,
	"./jv.js": 288,
	"./ka": 289,
	"./ka.js": 289,
	"./kk": 290,
	"./kk.js": 290,
	"./km": 291,
	"./km.js": 291,
	"./kn": 292,
	"./kn.js": 292,
	"./ko": 293,
	"./ko.js": 293,
	"./ku": 294,
	"./ku.js": 294,
	"./ky": 295,
	"./ky.js": 295,
	"./lb": 296,
	"./lb.js": 296,
	"./lo": 297,
	"./lo.js": 297,
	"./lt": 298,
	"./lt.js": 298,
	"./lv": 299,
	"./lv.js": 299,
	"./me": 300,
	"./me.js": 300,
	"./mi": 301,
	"./mi.js": 301,
	"./mk": 302,
	"./mk.js": 302,
	"./ml": 303,
	"./ml.js": 303,
	"./mn": 304,
	"./mn.js": 304,
	"./mr": 305,
	"./mr.js": 305,
	"./ms": 306,
	"./ms-my": 307,
	"./ms-my.js": 307,
	"./ms.js": 306,
	"./mt": 308,
	"./mt.js": 308,
	"./my": 309,
	"./my.js": 309,
	"./nb": 310,
	"./nb.js": 310,
	"./ne": 311,
	"./ne.js": 311,
	"./nl": 312,
	"./nl-be": 313,
	"./nl-be.js": 313,
	"./nl.js": 312,
	"./nn": 314,
	"./nn.js": 314,
	"./oc-lnc": 315,
	"./oc-lnc.js": 315,
	"./pa-in": 316,
	"./pa-in.js": 316,
	"./pl": 317,
	"./pl.js": 317,
	"./pt": 318,
	"./pt-br": 319,
	"./pt-br.js": 319,
	"./pt.js": 318,
	"./ro": 320,
	"./ro.js": 320,
	"./ru": 321,
	"./ru.js": 321,
	"./sd": 322,
	"./sd.js": 322,
	"./se": 323,
	"./se.js": 323,
	"./si": 324,
	"./si.js": 324,
	"./sk": 325,
	"./sk.js": 325,
	"./sl": 326,
	"./sl.js": 326,
	"./sq": 327,
	"./sq.js": 327,
	"./sr": 328,
	"./sr-cyrl": 329,
	"./sr-cyrl.js": 329,
	"./sr.js": 328,
	"./ss": 330,
	"./ss.js": 330,
	"./sv": 331,
	"./sv.js": 331,
	"./sw": 332,
	"./sw.js": 332,
	"./ta": 333,
	"./ta.js": 333,
	"./te": 334,
	"./te.js": 334,
	"./tet": 335,
	"./tet.js": 335,
	"./tg": 336,
	"./tg.js": 336,
	"./th": 337,
	"./th.js": 337,
	"./tk": 338,
	"./tk.js": 338,
	"./tl-ph": 339,
	"./tl-ph.js": 339,
	"./tlh": 340,
	"./tlh.js": 340,
	"./tr": 341,
	"./tr.js": 341,
	"./tzl": 342,
	"./tzl.js": 342,
	"./tzm": 343,
	"./tzm-latn": 344,
	"./tzm-latn.js": 344,
	"./tzm.js": 343,
	"./ug-cn": 345,
	"./ug-cn.js": 345,
	"./uk": 346,
	"./uk.js": 346,
	"./ur": 347,
	"./ur.js": 347,
	"./uz": 348,
	"./uz-latn": 349,
	"./uz-latn.js": 349,
	"./uz.js": 348,
	"./vi": 350,
	"./vi.js": 350,
	"./x-pseudo": 351,
	"./x-pseudo.js": 351,
	"./yo": 352,
	"./yo.js": 352,
	"./zh-cn": 353,
	"./zh-cn.js": 353,
	"./zh-hk": 354,
	"./zh-hk.js": 354,
	"./zh-mo": 355,
	"./zh-mo.js": 355,
	"./zh-tw": 356,
	"./zh-tw.js": 356
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 579;

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env__ = __webpack_require__(203);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  user: [],
  token: null,
  screenHeight: 0,
  screenWidth: 0,
  isLoading: false,
  config: {},
  btnbottom: false,
  URLHost: __WEBPACK_IMPORTED_MODULE_2__config_env__["a" /* default */].apiUrl,
  URLBase: __WEBPACK_IMPORTED_MODULE_2__config_env__["a" /* default */].uiUrl,
  Keypublic: __WEBPACK_IMPORTED_MODULE_2__config_env__["a" /* default */].keyPublic,
  menu_data: [],
  TurnstileSiteKey: __WEBPACK_IMPORTED_MODULE_2__config_env__["a" /* default */].cloudfireSiteKey,
  TurnstileEnabled: __WEBPACK_IMPORTED_MODULE_2__config_env__["a" /* default */].cloudfireEnabled
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ })

},[536]);


// WEBPACK FOOTER //
// static/js/app.63df7d47edf3debfb296.js